import {
  WEBCHAT_LEAD_ORIGIN,
  WEBCHAT_LEAD_SENT_TO_SALES_CENTER,
} from 'modules/webchat/domain/constants';
import { ICreateWebchatLeadDTO } from 'modules/webchat/domain/dtos';
import { TWebchatVisitorType } from 'modules/webchat/domain/entities';
import { isDuplicatedPhoneError } from 'modules/webchat/domain/helpers';
import { ICustomersRepository } from 'shared/domain/repositories';

type TCreatedLeadType = Extract<TWebchatVisitorType, 'novo' | 'cadastrado'>;

/**
 * Cria o lead do visitante novo do pré-chat, sem e-mail. Se o Vectis recusar
 * por celular já cadastrado, a pessoa já existe: segue como 'cadastrado' e o
 * chat abre do mesmo jeito, sem criar outro lead.
 */
export default class CreateWebchatLeadUseCase {
  constructor(private customersRepository: ICustomersRepository) {}

  public async execute({
    name,
    phone,
    countryCode,
    unitId,
    terms,
    link,
  }: ICreateWebchatLeadDTO): Promise<TCreatedLeadType> {
    try {
      await this.customersRepository.create({
        name: name.trim(),
        phone,
        countryCode,
        unitId,
        sendToSalesCenter: WEBCHAT_LEAD_SENT_TO_SALES_CENTER,
        terms,
        optin: terms,
        origin: 'SITE',
        leadOrigin: {
          key: WEBCHAT_LEAD_ORIGIN.key,
          channel: WEBCHAT_LEAD_ORIGIN.channel,
          meta: { link },
        },
      });

      return 'novo';
    } catch (error) {
      if (isDuplicatedPhoneError(error)) return 'cadastrado';

      throw error;
    }
  }
}
